module.exports = __webpack_public_path__ + "static/media/adHocPoints.4b22eb55.png";